import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Mittral Life Science</h3>
          <p>Advancing Healthcare Through Innovation</p>
          <p style={{ marginTop: '0.5rem' }}>
            <strong>Address:</strong><br />
            Shop No. 3, Niwas Building,<br />
            Gandhinar Main Road, KL Colony,<br />
            Kopri, Thane – 400603,<br />
            Maharashtra, India
          </p>
          <p style={{ marginTop: '0.5rem' }}>
            <strong>Phone:</strong>{' '}
            <a href="tel:+918104526466" style={{ color: 'inherit' }}>+91-8104526466</a>
          </p>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:mittrallifesciencehelp@gmail.com" style={{ color: 'inherit' }}>
              mittrallifesciencehelp@gmail.com
            </a>
          </p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><Link to="/company-info">Company Info</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Connect With Us</h3>
          <div className="social-icons">
            <a href="https://linkedin.com/company/mittral-life-science" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="https://instagram.com/mittrallifescience" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://facebook.com/mittrallifescience" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <Link to="/contact" aria-label="Contact Us">
              <FaEnvelope />
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {currentYear} Mittral Life Science. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
